module.exports = __webpack_public_path__ + "img/icon-sb-black-friday-tag.c294a73.svg";